<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="EIS Contribution Rate"
      text="Edit EIS Contribution Rate"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-row no-gutters>
          <v-col cols="12">
            <v-text-field
              v-model="localEis.wages_from"
              v-validate="'required|twoDecimalValue'" 
              type="number"
              :error-messages="errors.collect('from')"
              data-vv-name="from"                
              data-vv-as="From"      
              prefix="RM"          
              label="From"
            />
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="localEis.wages_to"
              v-validate="'required|twoDecimalValue'" 
              type="number"
              :error-messages="errors.collect('to')"
              data-vv-name="to"                
              data-vv-as="To"  
              prefix="RM"          
              label="To"
            />
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="localEis.employer_contribution"
              v-validate="'required|twoDecimalValue'" 
              type="number"
              :error-messages="errors.collect('employer_contribution')"
              data-vv-name="employer_contribution"                
              data-vv-as="Employer Contribution"                
              label="Employer's Contribution"
              prefix="RM"
            />
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="localEis.employee_contribution"
              v-validate="'required|twoDecimalValue'" 
              type="number"
              :error-messages="errors.collect('employee_contribution')"
              data-vv-name="employee_contribution"                
              data-vv-as="Employee Contribution"                
              label="Employee's Contribution"
              prefix="RM"
            />
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="localEis.total"
              v-validate="'required|twoDecimalValue'" 
              type="number"
              :error-messages="errors.collect('total')"
              data-vv-name="total"                
              data-vv-as="Total"                
              label="Total"
              prefix="RM"
            />
          </v-col>
        </v-row> 
      </v-container>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import Big from 'big.js'
  export default {
    inject: ['$validator'],
    props: {
      eis: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localEis: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return
        this.localEis = { ...this.eis }
        this.localEis.wages_from = (this.localEis.wages_from / 100).toFixed(2)
        this.localEis.wages_to = (this.localEis.wages_to / 100).toFixed(2)
        this.localEis.employer_contribution = (this.localEis.employer_contribution / 100).toFixed(2)
        this.localEis.employee_contribution = (this.localEis.employee_contribution / 100).toFixed(2)
        this.localEis.total = (this.localEis.total / 100).toFixed(2)
      },
    },
    mounted () {
      let _this = this

      this.$validator.extend('twoDecimalValue', {
        getMessage (field, args) {
          return 'Only 2 Decimals are allowed'
        },
        validate (value, args) {
          return _this.isValidNumbers(value)
        },
      })
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            this.setProgressing(true)

            this.$api.eis().update(this.localEis.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })
                }
              })
              .catch(() => {})
              .then(() => {
                this.setProgressing(false)
                this.dialog = false 
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          wages_from: this.localEis.wages_from * 100,
          wages_to: this.localEis.wages_to * 100,
          employer_contribution: this.localEis.employer_contribution * 100,
          employee_contribution: this.localEis.employee_contribution * 100,
          total: this.localEis.total * 100,
        }
      },

      isValidNumbers (value) {
        return (new Big(value).times(10000) % 100 === 0)
      },
    },
  }
</script>
